import PersistentSidebarLayout from "../../../../components/PersistentSidebarLayout/PersistentSidebarLayout";
import Footer_component from "../../structure_components/desktop_screens/footer_component/Footer_component";
import HomeWorkContent from "./HomeWorkContent";
import "./HomeWork.scss";

export const HomeWorkView = () => {
  return (
    <>
      <div className="homework_wrapper">
        <div className="homework_inner_wrapper">
          <HomeWorkContent showBackArrow />
        </div>
      </div>
      <Footer_component />
    </>
  );
};

const HomeWork = () => {
  return (
    <PersistentSidebarLayout>
      <HomeWorkView />
    </PersistentSidebarLayout>
  );
};

export default HomeWork;
